import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { site } from "../../lib/site";
import { IconArrow, IconPhone } from "../Icon";
import { Reveal } from "../motion/Reveal";
import { Magnetic } from "../motion/Magnetic";

export function CTA() {
  return (
    <section className="section">
      <div className="container-page">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-brand-700 via-brand-600 to-brand-800 p-10 sm:p-14 text-white shadow-soft-lg">
            <motion.div
              className="pointer-events-none absolute -top-24 -right-20 h-72 w-72 rounded-full bg-accent-500/40 blur-3xl"
              aria-hidden="true"
              animate={{ x: [0, 20, 0], y: [0, -12, 0] }}
              transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
            />
            <motion.div
              className="pointer-events-none absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-brand-300/40 blur-3xl"
              aria-hidden="true"
              animate={{ x: [0, -18, 0], y: [0, 14, 0] }}
              transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
            />
            <div
              className="pointer-events-none absolute inset-0 opacity-30"
              aria-hidden="true"
              style={{
                backgroundImage:
                  "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.15), transparent 30%), radial-gradient(circle at 80% 80%, rgba(34,211,238,0.25), transparent 35%)",
              }}
            />

            <div className="relative max-w-3xl">
              <span className="inline-flex items-center gap-2 rounded-full bg-white/15 backdrop-blur px-3 py-1 text-xs font-semibold uppercase tracking-wider border border-white/20">
                Devis gratuit sous 48 h
              </span>
              <h2 className="mt-5 text-white">
                Un devis gratuit pour votre entretien à Vichy&nbsp;?
              </h2>
              <p className="mt-4 text-brand-50 text-lg">
                Décrivez-nous vos besoins - bureaux, copropriété, commerce, vitres, fin de
                chantier - nous revenons vers vous dans la journée.
              </p>
              <div className="mt-7 flex flex-wrap gap-3">
                <Magnetic>
                  <Link
                    to="/contact"
                    className="btn bg-white text-accent-800 px-6 py-3 shadow-soft hover:bg-accent-50 focus-visible:ring-white focus-visible:ring-offset-brand-700 group"
                  >
                    Demander mon devis
                    <IconArrow className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                  </Link>
                </Magnetic>
                <a
                  href={site.phoneHref}
                  className="btn inline-flex bg-white/10 hover:bg-white/20 text-white px-6 py-3 border border-white/30 transition-colors focus-visible:ring-white focus-visible:ring-offset-brand-700"
                >
                  <IconPhone className="h-4 w-4" />
                  {site.phoneDisplay}
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
